// import React, { useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FaTimes } from "react-icons/fa";

// const PaymentModal = ({
//   isOpen,
//   onClose,
//   onConfirm,
//   fareData,
//   isPaying,
//   serType,
//   seatTotal,
//   ssrType,
//   setAmount,
//   userWallet,
//   totalPayableAmount,
//   onWalletPay,
//   isWalletProcessing, // ✅ NEW
// }) => {
//   if (!isOpen) return null;

//   // Check data structure
//   const isRoundTrip = fareData?.isRoundTrip || false;

//   let onwardBase = 0;
//   let onwardTax = 0;
//   let onwardTotal = 0;
//   let returnBase = 0;
//   let returnTax = 0;
//   let returnTotal = 0;
//   let combinedTotal = 0;

//   if (isRoundTrip) {
//     // Round trip structure
//     onwardBase = Number(
//       fareData?.selectedOnwardFare?.base ||
//         fareData?.onwardFlight?.Fare?.total?.netfare ||
//         0
//     );
//     onwardTax = Number(
//       fareData?.selectedOnwardFare?.tax ||
//         fareData?.onwardFlight?.Fare?.total?.tax ||
//         0
//     );
//     onwardTotal = Number(
//       fareData?.selectedOnwardFare?.price ||
//         fareData?.onwardFlight?.Fare?.total?.total ||
//         0
//     );

//     returnBase = Number(
//       fareData?.selectedReturnFare?.base ||
//         fareData?.returnFlight?.Fare?.total?.netfare ||
//         0
//     );
//     returnTax = Number(
//       fareData?.selectedReturnFare?.tax ||
//         fareData?.returnFlight?.Fare?.total?.tax ||
//         0
//     );
//     returnTotal = Number(
//       fareData?.selectedReturnFare?.price ||
//         fareData?.returnFlight?.Fare?.total?.total ||
//         0
//     );

//     combinedTotal = fareData?.totalPrice || onwardTotal + returnTotal;
//   } else {
//     // One-way flight structure - using the selectedFare data you provided
//     const selectedFare = fareData?.selectedFare || {};
//     onwardBase = Number(selectedFare.base || 0);
//     onwardTax = Number(selectedFare.tax || 0);
//     onwardTotal = Number(selectedFare.price || 0);
//     combinedTotal = onwardTotal;
//   }

//   const combinedBase = onwardBase + returnBase;
//   const combinedTax = onwardTax + returnTax;

//   // Calculate convenience fee based on service type
//   const markupRate = serType === 1 ? 0.01 : 0.005;
//   const computedAgentMarkup = Math.round(combinedTotal * markupRate);

//   const numericSeatTotal = Number(seatTotal || 0);
//   const effectiveSeatTotal = ssrType === "with" ? numericSeatTotal : 0;

//   // Calculate final amount
//   const finalAmount = combinedTotal + computedAgentMarkup + effectiveSeatTotal;

//   // Update parent amount
//   useEffect(() => {
//     if (typeof setAmount === "function") {
//       setAmount(finalAmount);
//     }
//   }, [finalAmount, setAmount]);

//   return (
//     <AnimatePresence>
//       <motion.div
//         className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >
//         <motion.div
//           className="bg-white rounded-2xl shadow-lg w-full max-w-md md:max-w-lg p-6 relative"
//           initial={{ y: 80, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           exit={{ y: 80, opacity: 0 }}
//         >
//           {/* Close Button */}
//           <button
//             onClick={onClose}
//             className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
//           >
//             <FaTimes size={18} />
//           </button>

//           {/* Header */}
//           <h2 className="text-xl md:text-2xl font-semibold text-center mb-4">
//             Payment Summary
//           </h2>

//           {/* Fare Details */}
//           <div className="space-y-3 text-gray-700">
//             {/* Convenience Fee */}
//             <div className="flex justify-between">
//               <span>Convenience Fee:</span>
//               <span>₹{computedAgentMarkup}</span>
//             </div>

//             {isRoundTrip ? (
//               <>
//                 {/* Onward Flight */}
//                 <div className="border-b pb-2 mb-2">
//                   <h3 className="font-medium text-blue-600 mb-1">
//                     Onward Flight
//                   </h3>
//                   <div className="flex justify-between text-sm">
//                     <span>Base Fare:</span>
//                     <span>₹{onwardBase}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>Tax & Fees:</span>
//                     <span>₹{onwardTax}</span>
//                   </div>
//                   <div className="flex justify-between text-sm font-medium">
//                     <span>Subtotal:</span>
//                     <span>₹{onwardTotal}</span>
//                   </div>
//                 </div>

//                 {/* Return Flight */}
//                 <div className="border-b pb-2 mb-2">
//                   <h3 className="font-medium text-blue-600 mb-1">
//                     Return Flight
//                   </h3>
//                   <div className="flex justify-between text-sm">
//                     <span>Base Fare:</span>
//                     <span>₹{returnBase}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>Tax & Fees:</span>
//                     <span>₹{returnTax}</span>
//                   </div>
//                   <div className="flex justify-between text-sm font-medium">
//                     <span>Subtotal:</span>
//                     <span>₹{returnTotal}</span>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               /* One-way Flight */
//               <div className="border-b pb-2 mb-2">
//                 <h3 className="font-medium text-blue-600 mb-1">Flight Fare</h3>
//                 <div className="flex justify-between text-sm">
//                   <span>Base Fare:</span>
//                   <span>₹{onwardBase}</span>
//                 </div>
//                 <div className="flex justify-between text-sm">
//                   <span>Tax & Fees:</span>
//                   <span>₹{onwardTax}</span>
//                 </div>
//                 <div className="flex justify-between text-sm font-medium">
//                   <span>Subtotal:</span>
//                   <span>₹{onwardTotal}</span>
//                 </div>
//               </div>
//             )}

//             {/* Seat Cost */}
//             {effectiveSeatTotal > 0 && (
//               <div className="flex justify-between">
//                 <span>Seat Cost:</span>
//                 <span>₹{effectiveSeatTotal}</span>
//               </div>
//             )}

//             {/* Combined Totals for round trips */}
//             {isRoundTrip && (
//               <div className="border-t pt-2 mt-2">
//                 <div className="flex justify-between">
//                   <span>Total Base Fare:</span>
//                   <span>₹{combinedBase}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span>Total Tax & Fees:</span>
//                   <span>₹{combinedTax}</span>
//                 </div>
//               </div>
//             )}

//             <hr className="my-2" />

//             {/* Final Total */}
//             <div className="flex justify-between font-semibold text-lg">
//               <span>Total Amount:</span>
//               <span className="text-green-600">₹{finalAmount}</span>
//             </div>
//           </div>

//           {/* Payment Actions */}
//           <div className="mt-6 space-y-3">
//             {/* Wallet NOT active */}
//             {userWallet === null && (
//               <div className="bg-yellow-100 text-yellow-800 p-3 rounded-lg text-sm">
//                 Please go to your profile and click on <b>Activate Wallet</b>.
//                 Our team will contact you to activate your wallet.
//               </div>
//             )}

//             {/* Wallet active but insufficient balance */}
//             {userWallet !== null && userWallet < totalPayableAmount && (
//               <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm">
//                 Your wallet balance is insufficient. Please go to your profile
//                 and send a request to admin to increase your wallet amount.
//               </div>
//             )}

//             {/* Wallet active and sufficient */}
//             {userWallet !== null && userWallet >= totalPayableAmount && (
//               <button
//                 onClick={onWalletPay}
//                 disabled={isWalletProcessing || isPaying}
//                 className={`w-full py-3 rounded-xl text-white ${
//                   isWalletProcessing || isPaying
//                     ? "bg-green-300 cursor-not-allowed"
//                     : "bg-green-600 hover:bg-green-700"
//                 }`}
//               >
//                 {isWalletProcessing
//                   ? "Processing Wallet Payment..."
//                   : `Pay ₹${totalPayableAmount} using Wallet`}
//               </button>
//             )}

//             {/* Razorpay section */}
//             <div className="flex flex-col sm:flex-row gap-3">
//               <button
//                 onClick={onClose}
//                 className="w-full sm:w-1/2 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 text-gray-800"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={onConfirm}
//                 disabled={isPaying || isWalletProcessing}
//                 className={`w-full sm:w-1/2 py-2.5 rounded-xl text-white ${
//                   isPaying || isWalletProcessing
//                     ? "bg-blue-400 cursor-not-allowed"
//                     : "bg-blue-600 hover:bg-blue-700"
//                 }`}
//               >
//                 {isPaying
//                   ? "Processing..."
//                   : isWalletProcessing
//                   ? "Wallet Payment in Progress..."
//                   : "Pay with Razorpay"}
//               </button>
//             </div>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default PaymentModal;
import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaPlane, FaSuitcase, FaUtensils, FaExchangeAlt, FaClock, FaUser } from "react-icons/fa";
import { CheckCircle, XCircle, AlertCircle, Clock } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";
import { formatPriceSync } from "../utils/currency";
import { formatApiDateTime } from "../utils/flightUtils";

const getSegmentsFromFlight = (leg) => {
  if (!leg) return [];
  if (Array.isArray(leg)) return leg.filter((s) => s && s.flightNo);
  if (leg?.Flights?.Onward) {
    const o = leg.Flights.Onward;
    return Array.isArray(o) ? o.filter((s) => s && s.flightNo) : Object.values(o).filter((s) => s && s.flightNo);
  }
  if (typeof leg === "object") return Object.values(leg).filter((s) => s && s.flightNo);
  return [];
};

const formatSegmentDateTime = (seg) => {
  if (!seg) return { date: "—", time: "—" };
  const depDate = seg.depDate || seg.departureDate || "";
  const arrDate = seg.arrDate || seg.arrivalDate || "";
  let dateStr = "—", timeStr = "—";
  if (depDate && depDate.length >= 12) {
    dateStr = formatApiDateTime(depDate).split(",")[0]?.trim() || "—";
    timeStr = formatApiDateTime(depDate).split(",")[1]?.trim() || "—";
    if (arrDate && arrDate.length >= 12) {
      const arrPart = formatApiDateTime(arrDate).split(",")[1]?.trim();
      if (arrPart) timeStr = `${timeStr} – ${arrPart}`;
    }
  }
  return { date: dateStr, time: timeStr };
};

const PaymentModal = ({
  isOpen,
  onClose,
  onConfirm,
  fareData,
  isPaying,
  serType,
  seatTotal,
  ssrType,
  setAmount,
  setPriceSummary,
  userWallet,
  totalPayableAmount,
  onWalletPay,
  isWalletProcessing,
  totalPaxCount = 1,
  contactInfo,
  formPassengerData = [],
  webCheckinSelected = false,
}) => {
  const { currency } = useCurrency();
  if (!isOpen) return null;

  const isRoundTrip = fareData?.isRoundTrip || false;
  const paxCount = Math.max(1, Number(totalPaxCount) || 1);
  const showPerPersonBreakdown = paxCount > 1;

  const onwardSegments = getSegmentsFromFlight(fareData?.onwardFlight);
  const returnSegments = getSegmentsFromFlight(fareData?.returnFlight);
  const oneWaySegments = getSegmentsFromFlight(fareData?.flight);
  
  const numberOfSectors = isRoundTrip ? (onwardSegments.length + returnSegments.length) : (oneWaySegments.length || onwardSegments.length || 1);
  const baseWebCheckinCost = fareData?.ssrInfo?.web_checkin_amount || 79;
  const webCheckinUnitCost = baseWebCheckinCost * 2;
  const webCheckinTotalCost = webCheckinSelected ? (paxCount * numberOfSectors * webCheckinUnitCost) : 0;
  const onwardFirst = onwardSegments[0] || {};
  const onwardLast = onwardSegments[onwardSegments.length - 1] || {};
  const returnFirst = returnSegments[0] || {};
  const returnLast = returnSegments[returnSegments.length - 1] || {};
  const oneWayFirst = oneWaySegments[0] || {};
  const oneWayLast = oneWaySegments[oneWaySegments.length - 1] || {};
  const onwardAirline = onwardFirst?.airName || fareData?.onwardFlight?.Flights?.AirlineName || "—";
  const returnAirline = returnFirst?.airName || fareData?.returnFlight?.Flights?.AirlineName || "—";
  const oneWayAirline = fareData?.airlineName || oneWayFirst?.airName || fareData?.flight?.Flights?.AirlineName || "—";
  const onwardDt = formatSegmentDateTime(onwardFirst);
  const returnDt = formatSegmentDateTime(returnFirst);
  const oneWayDt = formatSegmentDateTime(oneWayFirst);

  let onwardBase = 0;
  let onwardTax = 0;
  let onwardTotal = 0;
  let returnBase = 0;
  let returnTax = 0;
  let returnTotal = 0;
  let combinedTotal = 0;

  if (isRoundTrip && !fareData?.isInternational) {
    onwardBase = Number(
      fareData?.selectedOnwardFare?.base ||
        fareData?.onwardFlight?.Fare?.total?.netfare ||
        0
    );
    onwardTax = Number(
      fareData?.selectedOnwardFare?.tax ||
        fareData?.onwardFlight?.Fare?.total?.tax ||
        0
    );
    onwardTotal = Number(
      fareData?.selectedOnwardFare?.price ||
        fareData?.onwardFlight?.Fare?.total?.total ||
        0
    );
    returnBase = Number(
      fareData?.selectedReturnFare?.base ||
        fareData?.returnFlight?.Fare?.total?.netfare ||
        0
    );
    returnTax = Number(
      fareData?.selectedReturnFare?.tax ||
        fareData?.returnFlight?.Fare?.total?.tax ||
        0
    );
    returnTotal = Number(
      fareData?.selectedReturnFare?.price ||
        fareData?.returnFlight?.Fare?.total?.total ||
        0
    );
    combinedTotal = fareData?.totalPrice || onwardTotal + returnTotal;
    
    // Fallback for missing breakdown
    if (onwardBase === 0 && onwardTax === 0 && onwardTotal > 0) {
      onwardBase = onwardTotal;
    } else if (onwardBase + onwardTax !== onwardTotal && onwardTotal > 0) {
      onwardBase = onwardTotal - onwardTax;
    }
    
    if (returnBase === 0 && returnTax === 0 && returnTotal > 0) {
      returnBase = returnTotal;
    } else if (returnBase + returnTax !== returnTotal && returnTotal > 0) {
      returnBase = returnTotal - returnTax;
    }
  } else {
    // One-way or International Round Trip (bundled fare)
    const selectedFare = fareData?.selectedFare || fareData;
    onwardBase = Number(selectedFare?.base || selectedFare?.basePrice || 0);
    onwardTax = Number(selectedFare?.tax || 0);
    onwardTotal = Number(fareData?.basePrice || selectedFare?.price || fareData?.totalPrice || 0);
    combinedTotal = fareData?.basePrice || fareData?.totalPrice || onwardTotal;
    
    // Fallback if base and tax are missing/zero but total is available
    if (onwardBase === 0 && onwardTax === 0 && combinedTotal > 0) {
      onwardBase = combinedTotal; // Assume entire amount is base fare if tax breakdown is missing
    } else if (onwardBase + onwardTax !== combinedTotal && combinedTotal > 0) {
      onwardBase = combinedTotal - onwardTax;
    }
  }

  const combinedBase = onwardBase + returnBase;
  const combinedTax = onwardTax + returnTax;

  // SSR add-ons: support per-passenger arrays or single selection (× paxCount); round trip domestic uses ssrInfo.baggageOption/mealOption, international uses ssrItems
  const onwardBagAmt = isRoundTrip
    ? Number(fareData?.selectedOnwardFare?.selectedBaggage?.baggAmt || fareData?.selectedOnwardFare?.ssrInfo?.baggageOption?.baggAmt || 0)
    : Number(fareData?.selectedFare?.selectedBaggage?.baggAmt || fareData?.selectedBaggage?.baggAmt || 0);
  const onwardMealAmt = isRoundTrip
    ? Number(fareData?.selectedOnwardFare?.selectedMeal?.mealAmt || fareData?.selectedOnwardFare?.ssrInfo?.mealOption?.mealAmt || 0)
    : Number(fareData?.selectedFare?.selectedMeal?.mealAmt || fareData?.selectedMeal?.mealAmt || 0);
  const returnBagAmt = Number(fareData?.selectedReturnFare?.selectedBaggage?.baggAmt || fareData?.selectedReturnFare?.ssrInfo?.baggageOption?.baggAmt || 0);
  const returnMealAmt = Number(fareData?.selectedReturnFare?.selectedMeal?.mealAmt || fareData?.selectedReturnFare?.ssrInfo?.mealOption?.mealAmt || 0);
  const internationalSSRAmt = (fareData?.ssrItems?.onward || []).reduce((s, i) => s + Number(i?.baggAmt || i?.mealAmt || 0), 0) +
    (fareData?.ssrItems?.return || []).reduce((s, i) => s + Number(i?.baggAmt || i?.mealAmt || 0), 0);

  const hasPerPaxSSR = Array.isArray(fareData?.selectedBaggagePerPax) || Array.isArray(fareData?.selectedMealPerPax);
  let totalSSRAmt = 0;
  if (hasPerPaxSSR) {
    const bagPerPax = fareData?.selectedBaggagePerPax || [];
    const mealPerPax = fareData?.selectedMealPerPax || [];
    const n = Math.max(bagPerPax.length, mealPerPax.length, paxCount);
    for (let i = 0; i < n; i++) {
      totalSSRAmt += Number(bagPerPax[i]?.baggAmt || 0) + Number(mealPerPax[i]?.mealAmt || 0);
    }
  } else if (internationalSSRAmt > 0) {
    totalSSRAmt = internationalSSRAmt; // DO NOT multiply by paxCount, ssrItems array already has per-passenger items
  } else {
    const singlePaxSSR = onwardBagAmt + onwardMealAmt + returnBagAmt + returnMealAmt;
    totalSSRAmt = singlePaxSSR * paxCount;
  }

  // When user chose "Book without add-ons" (ssrType === "without"), do NOT add add-ons to total
  const effectiveSSRAmt = ssrType === "with" ? totalSSRAmt : 0;

  // Calculate convenience fee based on service type
  const markupRate = serType === 1 ? 0.01 : 0.005;
  const computedAgentMarkup = Math.round(combinedTotal * markupRate);

  const numericSeatTotal = Number(seatTotal || 0);
  const effectiveSeatTotal = ssrType === "with" ? numericSeatTotal : 0;

  const finalAmount = combinedTotal + effectiveSSRAmt + computedAgentMarkup + effectiveSeatTotal + webCheckinTotalCost;

  // Update parent amount
  useEffect(() => {
    if (setAmount) {
      setAmount(finalAmount);
    }
    if (setPriceSummary) {
      setPriceSummary({
        baseFare: combinedTotal,
        ssrAmount: effectiveSSRAmt,
        seatTotalCost: effectiveSeatTotal,
        webCheckin: webCheckinTotalCost,
        markup: computedAgentMarkup,
        total: finalAmount,
      });
    }
  }, [finalAmount, setAmount, setPriceSummary]);

  const getWalletStatus = () => {
    // DEBUG logging
    console.log("Checking wallet in PaymentModal:", userWallet);

    // If userWallet is a number (balance only)
    if (typeof userWallet === "number") {
      return {
        status: "active",
        message: "Wallet is active",
        canUseWallet: userWallet >= totalPayableAmount,
        balance: userWallet,
      };
    }

    // If userWallet is an object with isActive property
    if (userWallet && typeof userWallet === "object") {
      // Check for different possible property names
      const isActive =
        userWallet.isActive ||
        userWallet.active ||
        userWallet.status === "active" ||
        false;

      const balance =
        userWallet.balance ||
        userWallet.amount ||
        userWallet.currentBalance ||
        0;

      if (isActive) {
        return {
          status: "active",
          message: "Wallet is active and ready to use",
          canUseWallet: balance >= totalPayableAmount,
          balance: balance,
        };
      } else {
        return {
          status: "inactive",
          message: "Wallet is not active",
          canUseWallet: false,
          balance: balance,
        };
      }
    }

    // Default - wallet not activated
    return {
      status: "not_activated",
      message: "Wallet is not activated",
      canUseWallet: false,
      balance: 0,
    };
  };

  const walletStatus = getWalletStatus();

  // Get status badge component
  const StatusBadge = ({ status }) => {
    switch (status) {
      case "active":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
            <CheckCircle className="w-4 h-4 mr-1" />
            Active
          </div>
        );
      case "pending":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-sm font-medium">
            <Clock className="w-4 h-4 mr-1" />
            Pending
          </div>
        );
      case "deactivated":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-100 text-red-800 text-sm font-medium">
            <XCircle className="w-4 h-4 mr-1" />
            Deactivated
          </div>
        );
      case "inactive":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-gray-800 text-sm font-medium">
            <AlertCircle className="w-4 h-4 mr-1" />
            Inactive
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 py-6 px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden border border-gray-200/60"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
        >
          <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-white shrink-0 rounded-t-2xl">
            <h2 className="text-lg font-bold text-gray-900 tracking-tight">Payment Summary</h2>
            <button onClick={onClose} type="button" className="text-gray-400 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Close">
              <FaTimes size={20} />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-5 space-y-5">
            {/* 1. Flight details – cards */}
            <section>
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Flight details</p>
              {isRoundTrip ? (
                <div className="space-y-3">
                  <div className="rounded-xl border border-blue-200/80 bg-white shadow-sm overflow-hidden">
                    <div className="px-3 py-2 bg-blue-600">
                      <span className="text-xs font-bold text-white uppercase tracking-wide flex items-center gap-1.5"><FaPlane className="opacity-90" /> Onward</span>
                    </div>
                    <div className="p-3 space-y-1.5">
                      <div className="flex items-center gap-2 text-gray-800">
                        <span className="font-bold">{onwardFirst?.depCode || "—"}</span>
                        <FaExchangeAlt className="text-blue-500 text-xs" />
                        <span className="font-bold">{onwardLast?.arrCode || "—"}</span>
                      </div>
                      <p className="text-xs text-gray-600">{onwardAirline} • {onwardFirst?.flightNo || "—"}</p>
                      <div className="flex items-center gap-2 text-xs text-gray-500">
                        <FaClock className="shrink-0" /><span>{onwardDt.date}</span><span className="text-gray-400">|</span><span>{onwardDt.time}</span>
                      </div>
                      <div className="flex justify-between items-baseline pt-1.5 border-t border-gray-100">
                        <span className="text-xs text-gray-600">{fareData?.selectedOnwardFare?.name || "Fare"}</span>
                        <span className="font-bold text-blue-600 text-sm">{formatPriceSync(onwardTotal, currency)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-xl border border-green-200/80 bg-white shadow-sm overflow-hidden">
                    <div className="px-3 py-2 bg-green-600">
                      <span className="text-xs font-bold text-white uppercase tracking-wide flex items-center gap-1.5"><FaPlane className="opacity-90" /> Return</span>
                    </div>
                    <div className="p-3 space-y-1.5">
                      <div className="flex items-center gap-2 text-gray-800">
                        <span className="font-bold">{returnFirst?.depCode || "—"}</span>
                        <FaExchangeAlt className="text-green-500 text-xs" />
                        <span className="font-bold">{returnLast?.arrCode || "—"}</span>
                      </div>
                      <p className="text-xs text-gray-600">{returnAirline} • {returnFirst?.flightNo || "—"}</p>
                      <div className="flex items-center gap-2 text-xs text-gray-500">
                        <FaClock className="shrink-0" /><span>{returnDt.date}</span><span className="text-gray-400">|</span><span>{returnDt.time}</span>
                      </div>
                      <div className="flex justify-between items-baseline pt-1.5 border-t border-gray-100">
                        <span className="text-xs text-gray-600">{fareData?.selectedReturnFare?.name || "Fare"}</span>
                        <span className="font-bold text-green-600 text-sm">{formatPriceSync(returnTotal, currency)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="rounded-xl border border-blue-200/80 bg-white shadow-sm overflow-hidden">
                  <div className="px-3 py-2 bg-blue-600">
                    <span className="text-xs font-bold text-white uppercase tracking-wide flex items-center gap-1.5"><FaPlane className="opacity-90" /> Flight</span>
                  </div>
                  <div className="p-3 space-y-1.5">
                    <div className="flex items-center gap-2 text-gray-800">
                      <span className="font-bold">{oneWayFirst?.depCode || "—"}</span>
                      <FaExchangeAlt className="text-blue-500 text-xs" />
                      <span className="font-bold">{oneWayLast?.arrCode || "—"}</span>
                    </div>
                    <p className="text-xs text-gray-600">{oneWayAirline} • {oneWayFirst?.flightNo || "—"}</p>
                    <div className="flex items-center gap-2 text-xs text-gray-500">
                      <FaClock className="shrink-0" /><span>{oneWayDt.date}</span><span className="text-gray-400">|</span><span>{oneWayDt.time}</span>
                    </div>
                    <div className="flex justify-between items-baseline pt-1.5 border-t border-gray-100">
                      <span className="text-xs text-gray-600">{fareData?.selectedFare?.fareTypeDesc || fareData?.selectedFare?.fareName || "Fare"}</span>
                      <span className="font-bold text-blue-600 text-sm">{formatPriceSync(onwardTotal, currency)}</span>
                    </div>
                  </div>
                </div>
              )}
            </section>

            {/* 2. Travellers – optional */}
            {(formPassengerData?.length > 0 || contactInfo) && (
              <section>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Travellers & contact</p>
                <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4 space-y-2">
                  {formPassengerData.map((pax, i) => {
                    const firstName = pax?.fName || pax?.firstName || "";
                    const lastName = pax?.lName || pax?.lastName || "";
                    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
                    return (
                      <div key={i} className="flex items-center justify-between text-sm text-gray-700">
                        <span className="flex items-center gap-2">
                          <FaUser className="text-gray-400 text-xs" />
                          Passenger {i + 1}: {pax?.title || ""} {fullName || "—"}
                        </span>
                        <span className="text-xs text-gray-500 capitalize">{pax?.passengerType || "Adult"}</span>
                      </div>
                    );
                  })}
                  {contactInfo?.email && (
                    <div className="text-xs text-gray-600 pt-2 border-t border-gray-200">
                      Contact: {contactInfo.email}{contactInfo?.mobile ? ` • ${contactInfo.mobile}` : ""}
                    </div>
                  )}
                </div>
              </section>
            )}

            {/* 3. Pricing breakdown */}
            <section>
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Pricing breakdown</p>
              <div className="rounded-xl border-2 border-gray-200 bg-white p-4 shadow-sm space-y-2">
                <div className="flex justify-between text-sm text-gray-700">
                  <span>Base fare {isRoundTrip ? "(onward + return)" : ""}</span>
                  <span>{formatPriceSync(combinedBase, currency)}</span>
                </div>
                <div className="flex justify-between text-sm text-gray-700">
                  <span>Taxes & fees</span>
                  <span>{formatPriceSync(combinedTax, currency)}</span>
                </div>
                {showPerPersonBreakdown && (
                  <div className="flex justify-between text-xs text-gray-500 pl-1">
                    <span>× {paxCount} passenger{paxCount > 1 ? "s" : ""}</span>
                    <span>{formatPriceSync(combinedTotal, currency)}</span>
                  </div>
                )}
                {ssrType === "with" && effectiveSSRAmt > 0 && (
                  <div className="flex justify-between text-sm text-gray-700 pt-1">
                    <span className="flex items-center gap-1.5"><FaSuitcase className="text-slate-500 text-xs" /> Add-ons (baggage / meals)</span>
                    <span>+{formatPriceSync(effectiveSSRAmt, currency)}</span>
                  </div>
                )}
                {effectiveSeatTotal > 0 && (
                  <div className="flex justify-between text-sm text-gray-700">
                    <span>Seat selection</span>
                    <span>+{formatPriceSync(effectiveSeatTotal, currency)}</span>
                  </div>
                )}
                {webCheckinSelected && (
                  <div className="flex justify-between text-sm text-gray-700">
                    <span>Web Check-in</span>
                    <span>+{formatPriceSync(webCheckinTotalCost, currency)}</span>
                  </div>
                )}
                <div className="flex justify-between text-sm text-gray-700">
                  <span>Convenience fee</span>
                  <span>+{formatPriceSync(computedAgentMarkup, currency)}</span>
                </div>
                <div className="flex justify-between items-baseline pt-3 mt-2 border-t-2 border-gray-200">
                  <span className="font-bold text-gray-900">Total amount</span>
                  <span className="text-xl font-bold text-gray-900">{formatPriceSync(finalAmount, currency)}</span>
                </div>
              </div>
            </section>

            {/* 4. Wallet status */}
            <section>
              <div className="rounded-xl border border-gray-200 bg-gray-50/80 p-4">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-700">Wallet</span>
                  <StatusBadge status={walletStatus.status} />
                </div>
                <p className="text-xs text-gray-600 mt-0.5">{walletStatus.message}</p>
                {walletStatus.status === "active" && (
                  <div className="mt-2 flex justify-between items-center text-sm">
                    <span className="text-gray-600">Available balance</span>
                    <span className="font-semibold text-green-600">{formatPriceSync(walletStatus.balance, currency)}</span>
                  </div>
                )}
              </div>
            </section>
          </div>

          {/* Payment Actions – fare breakdown shown above in Pricing breakdown */}
          <div className="shrink-0 border-t border-gray-200 bg-white px-5 py-4 space-y-3 rounded-b-2xl">
            {null && (isRoundTrip ? (
              <>
                {/* Onward Flight */}
                <div className="border-b pb-2 mb-2">
                  <h3 className="font-medium text-blue-600 mb-1">
                    Onward Flight
                  </h3>
                  <div className="flex justify-between text-sm">
                    <span>Base Fare:</span>
                    <span>{formatPriceSync(onwardBase, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Tax & Fees:</span>
                    <span>{formatPriceSync(onwardTax, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm font-medium">
                    <span>Subtotal:</span>
                    <span>{formatPriceSync(onwardTotal, currency)}</span>
                  </div>
                </div>

                {/* Return Flight */}
                <div className="border-b pb-2 mb-2">
                  <h3 className="font-medium text-blue-600 mb-1">
                    Return Flight
                  </h3>
                  <div className="flex justify-between text-sm">
                    <span>Base Fare:</span>
                    <span>{formatPriceSync(returnBase, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Tax & Fees:</span>
                    <span>{formatPriceSync(returnTax, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm font-medium">
                    <span>Subtotal:</span>
                    <span>{formatPriceSync(returnTotal, currency)}</span>
                  </div>
                </div>
                {showPerPersonBreakdown && (
                  <div className="border-b pb-2 mb-2 pl-1 text-sm text-slate-600">
                    <div className="flex justify-between">
                      <span>Per person (flight):</span>
                      <span>{formatPriceSync(combinedTotal / paxCount, currency)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>× {paxCount} passenger{paxCount > 1 ? "s" : ""}:</span>
                      <span className="font-medium text-slate-800">{formatPriceSync(combinedTotal, currency)}</span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="border-b pb-2 mb-2">
                <h3 className="font-medium text-blue-600 mb-1">Flight Fare</h3>
                <div className="flex justify-between text-sm">
                  <span>Base Fare:</span>
                  <span>{formatPriceSync(onwardBase, currency)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>Tax & Fees:</span>
                  <span>{formatPriceSync(onwardTax, currency)}</span>
                </div>
                <div className="flex justify-between text-sm font-medium">
                  <span>Subtotal:</span>
                  <span>{formatPriceSync(onwardTotal, currency)}</span>
                </div>
                {showPerPersonBreakdown && (
                  <>
                    <div className="flex justify-between text-sm mt-1.5 text-slate-600">
                      <span>Per person:</span>
                      <span>{formatPriceSync(combinedTotal / paxCount, currency)}</span>
                    </div>
                    <div className="flex justify-between text-sm text-slate-600">
                      <span>× {paxCount} passenger{paxCount > 1 ? "s" : ""}:</span>
                      <span className="font-medium text-slate-800">{formatPriceSync(combinedTotal, currency)}</span>
                    </div>
                  </>
                )}
              </div>
            ))}

            {null && (<>
            {/* SSR add-ons (Baggage / Meals) – only when user chose "Include add-ons" (ssrType === "with") */}
            {ssrType === "with" && effectiveSSRAmt > 0 && (
              <div className="border-b pb-2 mb-2">
                <h3 className="font-medium text-slate-700 mb-1.5 flex items-center gap-1.5">
                  <FaSuitcase className="text-slate-500" />
                  Add-ons
                </h3>
                {hasPerPaxSSR ? (
                  <>
                    {(fareData?.selectedBaggagePerPax || []).map((bag, i) => bag && (
                      <div key={`bag-${i}`} className="flex justify-between text-sm text-slate-600">
                        <span>Passenger {i + 1} – Baggage</span>
                        <span>{formatPriceSync(Number(bag.baggAmt || 0), currency)}</span>
                      </div>
                    ))}
                    {(fareData?.selectedMealPerPax || []).map((meal, i) => meal && (
                      <div key={`meal-${i}`} className="flex justify-between text-sm text-slate-600">
                        <span>Passenger {i + 1} – Meal</span>
                        <span>{formatPriceSync(Number(meal.mealAmt || 0), currency)}</span>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {onwardBagAmt > 0 && (
                      <div className="flex justify-between text-sm text-slate-600">
                        <span>Baggage (onward){showPerPersonBreakdown ? ` (× ${paxCount})` : ""}</span>
                        <span>{formatPriceSync(onwardBagAmt * (showPerPersonBreakdown ? paxCount : 1), currency)}</span>
                      </div>
                    )}
                    {onwardMealAmt > 0 && (
                      <div className="flex justify-between text-sm text-slate-600">
                        <span>Meal (onward){showPerPersonBreakdown ? ` (× ${paxCount})` : ""}</span>
                        <span>{formatPriceSync(onwardMealAmt * (showPerPersonBreakdown ? paxCount : 1), currency)}</span>
                      </div>
                    )}
                    {returnBagAmt > 0 && (
                      <div className="flex justify-between text-sm text-slate-600">
                        <span>Baggage (return){showPerPersonBreakdown ? ` (× ${paxCount})` : ""}</span>
                        <span>{formatPriceSync(returnBagAmt * (showPerPersonBreakdown ? paxCount : 1), currency)}</span>
                      </div>
                    )}
                    {returnMealAmt > 0 && (
                      <div className="flex justify-between text-sm text-slate-600">
                        <span>Meal (return){showPerPersonBreakdown ? ` (× ${paxCount})` : ""}</span>
                        <span>{formatPriceSync(returnMealAmt * (showPerPersonBreakdown ? paxCount : 1), currency)}</span>
                      </div>
                    )}
                  </>
                )}
                <div className="flex justify-between text-sm font-medium mt-1">
                  <span>Add-ons total</span>
                  <span>{formatPriceSync(effectiveSSRAmt, currency)}</span>
                </div>
              </div>
            )}

            {/* Seat Cost */}
            {effectiveSeatTotal > 0 && (
              <div className="flex justify-between">
                <span>Seat Cost:</span>
                <span>{formatPriceSync(effectiveSeatTotal, currency)}</span>
              </div>
            )}

            {/* Combined Totals for round trips */}
            {isRoundTrip && (
              <div className="border-t pt-2 mt-2">
                <div className="flex justify-between">
                  <span>Total Base Fare:</span>
                  <span>{formatPriceSync(combinedBase, currency)}</span>
                </div>
                <div className="flex justify-between">
                  <span>Total Tax & Fees:</span>
                  <span>{formatPriceSync(combinedTax, currency)}</span>
                </div>
              </div>
            )}

            <hr className="my-2" />

            {/* Final Total */}
            <div className="flex justify-between font-semibold text-lg">
              <span>Total Amount:</span>
              <span className="text-green-600">{formatPriceSync(finalAmount, currency)}</span>
            </div>
            </>)}

          {/* Payment Actions */}
          <div className="mt-6 space-y-3">
            {/* Wallet NOT active or insufficient */}
            {(!walletStatus.canUseWallet ||
              walletStatus.status !== "active") && (
              <div
                className={`p-3 rounded-lg text-sm ${
                  walletStatus.status === "pending"
                    ? "bg-yellow-100 text-yellow-800"
                    : walletStatus.status === "deactivated"
                    ? "bg-red-100 text-red-700"
                    : walletStatus.status === "inactive" ||
                      walletStatus.status === "not_activated"
                    ? "bg-blue-100 text-blue-800"
                    : walletStatus.balance < totalPayableAmount
                    ? "bg-orange-100 text-orange-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {walletStatus.status === "not_activated" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Not Activated</div>
                    <div>
                      Please go to your profile and click on{" "}
                      <b>Activate Wallet</b>. Our team will contact you to
                      activate your wallet.
                    </div>
                  </div>
                )}

                {walletStatus.status === "pending" && (
                  <div>
                    <div className="font-medium mb-1">
                      Wallet Activation Pending
                    </div>
                    <div>
                      Your wallet activation request is under review. You will
                      be notified once it's approved.
                    </div>
                  </div>
                )}

                {walletStatus.status === "deactivated" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Deactivated</div>
                    <div>
                      Your wallet has been deactivated. Please go to your
                      profile to request reactivation.
                    </div>
                  </div>
                )}

                {walletStatus.status === "inactive" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Inactive</div>
                    <div>
                      Please activate your wallet from your profile section to
                      use wallet payments.
                    </div>
                  </div>
                )}

                {walletStatus.status === "active" &&
                  walletStatus.balance < totalPayableAmount && (
                    <div>
                      <div className="font-medium mb-1">
                        Insufficient Wallet Balance
                      </div>
                      <div>
                        Your wallet balance ({formatPriceSync(walletStatus.balance, currency)}) is less
                        than total amount ({formatPriceSync(totalPayableAmount, currency)}). Please add
                        funds to your wallet.
                      </div>
                    </div>
                  )}
              </div>
            )}

            {/* Wallet active and sufficient */}
            {walletStatus.canUseWallet && (
              <button
                onClick={onWalletPay}
                disabled={isWalletProcessing || isPaying}
                className={`w-full py-3 rounded-xl text-white ${
                  isWalletProcessing || isPaying
                    ? "bg-green-300 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {isWalletProcessing
                  ? "Processing Wallet Payment..."
                  : `Pay ${formatPriceSync(totalPayableAmount, currency)} using Wallet`}
              </button>
            )}

            {/* Razorpay section */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onClose}
                className="w-full sm:w-1/2 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 text-gray-800"
              >
                Cancel
              </button>

              <button
                onClick={onConfirm}
                disabled={isPaying || isWalletProcessing}
                className={`w-full sm:w-1/2 py-2.5 rounded-xl text-white ${
                  isPaying || isWalletProcessing
                    ? "bg-blue-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {isPaying
                  ? "Processing..."
                  : isWalletProcessing
                  ? "Wallet Payment in Progress..."
                  : "Pay with Razorpay"}
              </button>
            </div>
          </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PaymentModal;
